/** Chuỗi Pha E ở web quầy: chăm khách, chờ chỗ, điểm thưởng. Tiếng Việt có dấu. */
type Loai = 'sinh-nhat' | 'lau-chua-quay-lai' | 'goi-sap-het'

export const C = {
  tabTim: 'Tìm khách',
  tabCham: 'Chăm khách',
  tabCho: 'Chờ chỗ',
  tieuDe: 'Chăm khách',
  // N3: đến hạn quay lại
  denHan: 'Đến hạn',
  denHanMoTa: 'Khách tới lúc làm lại, chưa đặt lịch mới',
  denHanDong: (dichVu: string, lanCuoi: string, han: string) =>
    `${dichVu} · làm ${lanCuoi} · đến hạn ${han}`,
  denHanTrong: 'Chưa có khách nào tới hạn quay lại.',
  denHanTrongPhu: 'Khách làm xong sẽ hiện ở đây khi tới hạn làm lại.',
  denHanSuaChuKy: 'Sửa số ngày quay lại',
  denHanChep: 'Chép lời mời',
  denHanChepMoZalo: 'Chép lời mời & mở Zalo',
  denHanDaChep: 'Đã chép lời mời. Dán vào chat Zalo của khách rồi gửi.',
  denHanChepLoi: 'Chưa chép được. Bạn giữ tay vào lời mời để chép nhé.',
  denHanDaLienHe: 'Đã liên hệ',
  denHanChuaDongYTin: 'Khách chưa đồng ý nhận tin — không gửi lời mời.',
  denHanDaAn: (ten: string) => `Đã ghi. ${ten} ẩn khỏi danh sách 14 ngày.`,
  sinhNhat: 'Sinh nhật',
  lauChuaQuayLai: 'Lâu chưa tới',
  goiSapHet: 'Gói sắp hết',
  soNgayNhan: 'Bao lâu chưa quay lại',
  soNgay: (n: number) => `${n} ngày`,
  chuaQuayLaiHon: 'Chưa quay lại hơn',
  moTa: {
    'sinh-nhat': 'Khách có sinh nhật trong 7 ngày tới',
    'lau-chua-quay-lai': 'Lâu chưa tới, chưa đặt lịch mới',
    'goi-sap-het': 'Gói còn buổi, hết hạn trong 14 ngày',
  } as Record<Loai, string>,
  soKhach: (n: number) => `${n} khách`,
  uocTinh: (n: number, tien: string) =>
    `${n} khách đồng ý nhận tin · nếu gửi tin ước khoảng ${tien}`,
  // Chỉ hiện khi tiệm THẬT SỰ đang gửi tin nhắc gói tự động (API trả `tuDongGui: true`, B7 10/10/2026).
  daTuDong: 'Tin nhắc gói qua Zalo được gửi tự động cho khách đã đồng ý nhận tin.',
  chuaTuDong:
    'Chưa gửi tự động được: Zalo cần duyệt mẫu tin ưu đãi cho tài khoản Zalo của tiệm. Trong lúc chờ, bạn bấm gọi hoặc mở chat Zalo từng khách.',
  // Gói sắp hết khi tin Zalo tự động CHƯA bật: quầy phải nhắc tay.
  chuaTuDongGoi:
    'Tin Zalo tự động chưa bật nên bạn cần nhắc khách: bấm gọi hoặc mở chat Zalo từng người.',
  trong: {
    'sinh-nhat': 'Chưa có khách nào sinh nhật tuần này.',
    'lau-chua-quay-lai': 'Không có khách nào lâu chưa quay lại.',
    'goi-sap-het': 'Không có gói nào sắp hết hạn.',
  } as Record<Loai, string>,
  // Mốc của mỗi dòng, TÁCH chữ và ngày: chỉ NGÀY được giữ liền một dòng (nowrap), phần chữ tự xuống dòng trong cột hẹp
  // (v0.23.2 vòng sửa 1, W2: nowrap cả cụm làm "lần cuối 27/09/202" bị cắt ở 320px). Ghép lại vẫn đúng câu cũ.
  moc: {
    'sinh-nhat': (ngay: string) => ({ truoc: 'sinh ngày ', ngay: ngay.slice(0, 5) }),
    'lau-chua-quay-lai': (ngay: string) => ({ truoc: 'lần cuối ', ngay }),
    'goi-sap-het': (ngay: string) => ({ truoc: 'gói hết hạn ', ngay }),
  } as Record<Loai, (ngay: string) => { truoc: string; ngay: string }>,
  dongYNhan: 'đồng ý nhận tin',
  trongPhu: {
    'sinh-nhat': 'Ghi ngày sinh ở thẻ khách (Tìm khách → mở khách) để danh sách này có người.',
    'lau-chua-quay-lai': 'Khách lâu không tới sẽ hiện ở đây để quầy gọi mời lại.',
    'goi-sap-het': 'Gói còn buổi sắp hết hạn sẽ hiện ở đây để quầy nhắc khách.',
  } as Record<Loai, string>,
  chiNhanh: 'Chi nhánh',
  khongSo: 'Chưa có số',
  goi: 'Gọi khách',
  chatZalo: 'Mở chat Zalo',
  khongAiCho: 'Chưa có khách nào chờ chỗ.',
  khongAiChoPhu: 'Khi ngày kín lịch, khách bấm "Báo tôi khi có chỗ" trong Zalo sẽ hiện ở đây.',
  coCho: (gio: string) => `Có chỗ ${gio}`,
  coChoGoi: 'Gọi khách để giữ giờ này.',
  coChoTuDat: 'Khách thấy chỗ trống trong Zalo và tự đặt.',
  chuaCoCho: 'chưa có chỗ',

  diemTieuDe: 'Điểm thưởng',
  diemGoiY: 'Một quy tắc: tích điểm theo tiền khách trả thật, đổi điểm lấy giảm giá khi thu tiền.',
  batDiem: 'Bật điểm thưởng',
  tichMoi: 'Mỗi bao nhiêu đồng được 1 điểm',
  motDiem: '1 điểm đổi được',
  viDuDiem: (tich: string, gia: string) =>
    `Ví dụ: khách trả ${tich} được 1 điểm; 1 điểm giảm ${gia}.`,
  luuDiem: 'Lưu điểm thưởng',
  hoan: (pt: string) => `Khách được hoàn ${pt}% số tiền trả.`,
  hoanQuaCao: 'Hoàn tối đa 20%. Kiểm lại hai ô (có thể đã nhập đảo).',
  daLuuDiem: 'Đã lưu điểm thưởng',

  ngaySinh: 'Ngày sinh (không bắt buộc)',
  ngaySinhGoiY: 'ví dụ 25/09/1995 — để quầy chúc mừng',
  xoaNgaySinh: 'Xoá ngày sinh',
  ngaySinhSai: (loai: 'nam' | 'ngay') =>
    loai === 'nam' ? 'Năm sinh từ 1920 đến nay.' : 'Ngày này không có thật. Kiểm lại ngày / tháng.',
  sinhNgay: (_ngay: string) => 'Khách sẽ hiện trong danh sách Sinh nhật khi tới ngày.',
  luuNgaySinh: 'Lưu ngày sinh',
  daLuuNgaySinh: 'Đã lưu ngày sinh',
  doiDiem: (diem: string, tien: string) => `Đổi ${diem} điểm · giảm ${tien}`,
  coDiem: (diem: string) => `Khách có ${diem} điểm`,
  khongDuDoi: 'Chưa đủ để đổi lần này',
  dongDiem: (diem: string) => `Đổi ${diem} điểm`,
} as const
